import PersonnesController from './personnes.controller';

export default {
    template: require('./personnes.tpl.html'),
    controller: PersonnesController
};
